var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-pencil';
                    var viewUrl = 'sprite.svg#view-icon-pencil';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };